<app-navbar></app-navbar>
<app-home [news]="news"></app-home>

<app-videos [videos]="videos"></app-videos>
<app-presentation></app-presentation>
<app-bios></app-bios>
<app-concerts [concerts]="concerts"></app-concerts>
<app-pro></app-pro>
<app-contact></app-contact>
